module.exports = __webpack_public_path__ + "img/avatar2.7fd5ace9.png";